const Datanauts = () => {
    const datanauts = require(process.env.REACT_APP_JSON_FILENAME || './datanauts.json')
let year=0
    const _members = [], _countries = [], _cities = [], _industries = [], _classes = [], _genders = []
    let img=''
    datanauts.forEach((m, i) => {
        if (m) {
            const idCountry = countMember(_countries, m.country)
            const idCity = countMember(_cities, m.city, idCountry)
            
            _members.push({ ...m, idCountry, idCity })
            if (m.industry) {
                const industries = _replaceAll(_replaceAll(m.industry, '/', ','), ' and ', ',').split(',')
                industries.map(i => {
                    const industry = i.toLowerCase().trim()
                    if ([
                        "stay at home mom", "environment (need spring 2018 cohort button)", "actively looking for ds positions"
                    ].indexOf(industry) === -1) {
                        countMemberWithInIndustry(_industries, industry, idCountry, idCity)
                    }
                })
            }
            if (m.class) {
                updateMembers(_classes, m.class+m.year, { name: m.class, year: m.year }, idCountry, idCity)
                
            }
            if (m.gender) {
                updateMembers(_genders, m.gender, { name: m.gender === 'F' ? 'Female' : 'Male' }, idCountry, idCity)
            }
        }
    })
    
    function countMember(arr, name, idCountry, idCity) {
        const named = name || ('unknowed'+(idCountry ? '-'+idCountry : ''))
        let index = -1
        for (let i = 0; i < arr.length; ++i) {
            if (arr[i].name === named) {
                index = i
                break
            }
        }
        if (index === -1) {
            arr.push({ id: arr.length, name: named, members: 1, idCountry })
            return arr.length - 1
        } else {
            arr[index].members++
            return index
        }
    }

    function countMemberWithInIndustry(arr, name, idCountry, idCity) {
        const named = name || 'unknowed'
        let index = -1
        for (let i = 0; i < arr.length; ++i) {
            if (arr[i].name === named) {
                index = i
                break
            }
        }
        if (index === -1) {
            arr.push({ id: arr.length, name: named, members: 1, countries: [{ id: idCountry, industry: named, members: 1 }] })
            return arr.length - 1
        } else {
            arr[index].members++
            let indexc = -1
            for (let i = 0; i < arr[index].countries.length; ++i) {
                if (arr[index].countries[i].id === idCountry) {
                    indexc = i
                    break
                }
            }
            if (indexc === -1) {
                arr[index].countries.push({ id: idCountry, industry: named, members: 1 })
            } else {
                arr[index].countries[indexc].members++
            }

            return index
        }
    }

    //[{id,members,<attribs>,countries,cities},...]
    function updateMembers(arr, id, attribs, idCountry, idCity) {
        let index = -1
        for (let i = 0; i < arr.length; ++i) {
            if (arr[i].id === id) {
                index = i
                break
            }
        }
        if (index === -1) {
            arr.push({
                id, members: 1, attribs,
                countries: [{ id: idCountry, members: 1 }],
                cities: [{ id: idCity, members: 1 }]
            })
            return
        } else {
            arr[index].members++
            let indexc = -1
            for (let i = 0; i < arr[index].countries.length; ++i) {
                if (arr[index].countries[i].id === idCountry) {
                    indexc = i
                    break
                }
            }
            if (indexc === -1) {
                arr[index].countries.push({ id: idCountry, members: 1 })
            } else {
                arr[index].countries[indexc].members++
            }

            indexc = -1
            for (let i = 0; i < arr[index].cities.length; ++i) {
                if (arr[index].cities[i].id === idCity) {
                    indexc = i
                    break
                }
            }
            if (indexc === -1) {
                arr[index].cities.push({ id: idCity, members: 1 })
            } else {
                arr[index].cities[indexc].members++
            }

            return
        }
    }

    function _replaceAll(target, search, replacement) {
        return target.replace(new RegExp(search, 'g'), replacement);
    }

    function getCities(idCountry) {
        return _cities.filter(c => c.idCountry === idCountry)
    }

    function getCityCount() {
        return _cities.length
    }

    function getCountries() {
        return _countries
    }

    function getMembersByCountry(id) {
        return { country: _countries.filter(c => c.id === id)[0], members: _members.filter(c => c.idCountry === id) }
    }

    function getMembersByCity(id) {
        return { city: _cities.filter(c => c.id === id)[0], members: _members.filter(c => c.idCity === id) }
    }

    function getMembers() {
        return _members
    }

    function getMemberCount() {
        return _members.length
    }

    function getIndustries() {
        return _industries
    }

    function _getArrByCountry(arr, id) {
        let ret = []
        arr.forEach(i => {
            const countries = i.countries.filter(c => c.id === id)
            if (countries.length > 0) {
                ret = ret.concat(countries.map(c => {
                    return {
                        ...i,
                        members: c.members
                    }
                }))
            }
        })
        return ret
    }

    function getIndustriesByCountry(id) {
        let ret = []
        _industries.forEach(i => {
            const countries = i.countries.filter(c => c.id === id)
            if (countries.length > 0) {
                ret = ret.concat(countries.map(c => {
                    return {
                        name: c.industry,
                        members: c.members
                    }
                }))
            }
        })
        return ret
    }

    function getClasses() {
        return _classes.slice()
    }

    function getClassesByCountry(id) {
        return _getArrByCountry(_classes, id)
    }

    function getGenders() {
        return _genders.slice()
    }

    function getGendersByCountry(id) {
        return _getArrByCountry(_genders, id)
    }

    return {
        getCities,
        getCountries,
        getMembersByCountry,
        getMembersByCity,
        getMembers,
        getIndustries,
        getIndustriesByCountry,
        getCityCount,
        getMemberCount,
        getClasses,
        getClassesByCountry,
        getGenders,
        getGendersByCountry
    }
}

//module.exports = Datanauts()
export default Datanauts()